<template>
  <div class="expressManage">
    <OATable ref="expressManage" :data="data" :columns="columns" :filterData="filterData" :selectionRow="true"
      @search="handleSearch" :loading="loading" @selectionChange="selectionChange">
      <div slot="button">
        <OAButton @click="exportExpress" v-permission="'expressExportAll'">快递情况导出</OAButton>
        <OAButton @click="print" :disabled="!(checkList && checkList.length == 1 && checkList[0].trackStatus==-1)">重新打印
        </OAButton>
        <OAButton @click="sendExpress" class="pull-right">发快递</OAButton>
      </div>
    </OATable>
    <OAModalForm :title="titleText" :visible.sync="dialogVisible" :form-data="formData" @on-submit="submit"
      @on-cancel="cancel"></OAModalForm>
    <el-dialog :visible.sync="visibleTrack" width="500px" @close="trackClose" :lock-scroll="true" :title="trackTitle"
      custom-class="trackDialog">
      <div class="track-stateName">
        物流状态：<span class="stateName">{{trackData.stateName}}</span>
      </div>
      <el-timeline :reverse="reverse">
        <el-timeline-item v-for="(item, index) in trackData.data" :key="index" :timestamp="item.time" placement="top">
          <span class="stateName">{{item.stateName}}</span>
          <span>{{item.context}}</span>
        </el-timeline-item>
      </el-timeline>
    </el-dialog>
  </div>
</template>
<script>
  import OAModalForm from "@/components/OAModalForm/OAModalForm";
  import expressApi from "@/services/express.js";
  import {
    jump
  } from "@/common/jump";
  import OAHandle from "@/components/OAHandle/OAHandle";
  import {
    getUrlQuery,
    getValue,
    resFilter,
    setValue,
    clearValue
  } from "@/common/util.js";
  import moment from "moment"
  import api from "@/api/apiConfig"
  export default {
    name: "expressManage",
    components: {
      OAModalForm,
      OAHandle
    },
    data() {
      let that = this;
      return {
        filterData: {
          senderId: {
            formType: "a-auto-search",
            value: undefined,
            apiType: "getAll",
            col: 4,
            placeholder: "操作人"
          },
          departmentIds: {
            formType: "a-depart-cascader",
            value: undefined,
            col: 4,
            placeholder: "所在部门",
            options: []
          },
          senderCompanyId: {
            formType: "a-select",
            value: undefined,
            col: 4,
            api: "getCompany",
            props: {
              label: "companyName",
              value: "id"
            },
            placeholder: "发件公司"
          },
          trackStatus: {
            formType: "a-select",
            value: undefined,
            col: 4,
            api: "getCourierState",
            props: {
              label: "name",
              value: "code"
            },
            placeholder: "快递状态"
          },
          receiverName: {
            formType: "a-input",
            value: undefined,
            col: 4,
            placeholder: "收件客户"
          },
          goodsName: {
            formType: "a-input",
            value: undefined,
            col: 4,
            placeholder: "快递物品"
          },
          senderTime: {
            formType: "a-date-picker",
            type: "daterange",
            value: undefined,
            startPlaceholder: "发件开始",
            endPlaceholder: "发件结束",
            col: 4
          },
          appName: {
            formType: "a-select",
            value: undefined,
            col: 4,
            api: "getAppName",
            props: {
              label: "name",
              value: "code"
            },
            placeholder: "发件系统",
            options: []
          },
        },
        columns: [{
            title: "发件人",
            key: "senderName"
          },
          {
            title: "发件人所属部门",
            key: "departmentName",
            minWidth: 120,
            showOverflowTooltip: true
          },
          {
            title: "发件公司",
            key: "senderCompany",
            showOverflowTooltip: true
          },
          {
            title: "发送系统",
            key: "appName"
          },
          {
            title: "收件客户",
            key: "receiverName",
            showOverflowTooltip: true
          },
          {
            title: "审批状态",
            key: "statusName"
          },
          {
            title: "单号",
            key: "mailCode"
          },
          {
            title: "快递物品",
            key: "goodsName"
          },
          {
            title: "快递状态",
            key: "trackStatusName"
          },
          {
            title: "发件日期",
            key: "createTime",
            formatter(row, column, cellValue, index) {
              return moment(cellValue).format("YYYY-MM-DD")
            }
          },
          {
            title: "轨迹查询",
            key: "",
            minWidth: 80,
            component: {
              name: OAHandle,
              props: {
                text: "点击查看",
                onClick: function (val) {
                  that.viewRecord(val.row);
                }
              }
            }
          }
        ],
        data: [],
        loading: false,
        checkList: [],
        dialogVisible: false,
        titleText: '快递情况导出',
        formData: {
          senderCompanyId: {
            formType: "a-select",
            label: "发件公司：",
            placeholder: "请选择发件公司",
            api: "getCompany",
            props: {
              label: "companyName",
              value: "id"
            },
            multiple: true,
            value: [],
            rules: [{
              required: true,
              message: "请选择发件公司"
            }]
          },
          senderTime: {
            formType: "a-date-picker",
            type: "daterange",
            value: undefined,
            label: "发件时间：",
            rules: [{
              required: true,
              message: "请选择发件时间"
            }]
          }
        },
        visibleTrack: false,
        trackTitle: '轨迹',
        trackData: [],
        reverse: false
      };
    },
    mounted() {},
    methods: {
      async handleSearch(val) {
        this.loading = true;
        let res = await expressApi.getExpressManage(val);
        this.data = res.data.data;
        this.loading = false;
      },
      async print() {
        let res = await expressApi.print({
          id: this.checkList[0].id
        })
        if (res.data.data && res.data.data.status) {
          this.$message.success(res.data.data.message || '重新打印成功');
        } else {
          this.$message.warning(res.data.data.message || '重新打印失败');
        }
      },
      sendExpress() {
        jump({
          url: "addExpress"
        });
      },
      async viewRecord(row) {
        let result = await expressApi.expressTrack({
          comCode: row.comCode,
          mailNos: row.mailCode.split(' ')
        })
        this.trackData = result.data.data.trackList && result.data.data.trackList[0]
        this.visibleTrack = true
      },
      selectionChange(selection) {
        this.checkList = selection;
      },
      exportExpress() {
        this.dialogVisible = true
      },
      async submit() {
        let params = getValue(this.formData)
        var a = document.createElement('a');
        var url = '/api' + api.express.exportExcel + '?senderCompanyId=' + params.senderCompanyId +
          '&senderStartTime=' +
          params.senderTime[0] + '&senderEndTime=' + params.senderTime[1] + '&token=' + localStorage.getItem(
            "Authorization");
        a.href = url
        a.download = '快递情况.xls';
        a.click();
        window.URL.revokeObjectURL(url);
        this.cancel()
      },
      cancel() {
        clearValue(this.formData)
        this.dialogVisible = false
      },
      trackClose() {
        this.visibleTrack = false
      }
    }
  };

</script>
<style lang="scss">
  .trackDialog {
    padding-bottom: 20px;

    .track-stateName {
      font-size: 16px;
      margin-bottom: 20px;

      .stateName {
        font-weight: bold;
      }
    }

    .el-dialog__body {
      padding-top: 0;
      height: 400px;
      overflow-y: auto;

      .el-timeline-item__content {
        .stateName {
          font-size: 14px;
          font-weight: bold;
          margin-right: 10px;
          display: block;
        }
      }
    }

    .el-timeline {
      .el-timeline-item__node {
        background: #4998fd;
      }

      .el-timeline-item__tail {
        border-color: #4998fd;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/set/expressManage.vue